export default __webpack_public_path__ + "static/media/5.48b2fa7e.jpg";